// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"bb1e2b45","453":"07a6ab98","455":"e13d3ce7","970":"3bd5d366","977":"ee531c17"}[chunkId] + ".chunk.js";
};